import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import styles from '.././accountToggle.module.scss'
import { AccountToggleMobileProps } from '../types'
import BurgerMenu from './BurgerMenu'

const AccountToggleMobile = forwardRef<HTMLButtonElement, AccountToggleMobileProps>(
  ({ user, onClick, isMenuOpen, hasPendingMatches }, ref) => {
    const { t } = useTranslation(['strCommonUI'])

    return (
      <button
        ref={ref}
        className={classNames(styles.menuToggle, styles.mobileMenuToggle, {
          [styles.pressed]: isMenuOpen,
          [styles.iconNotificationBadge]: hasPendingMatches && !isMenuOpen,
        })}
        onClick={onClick}
        aria-label={t('ariaLabel.accountMenu', 'Account Menu')}
        aria-expanded={isMenuOpen}
        aria-controls='mobile-menu-main'
        data-testid='account-toggle-mobile'
      >
        <BurgerMenu isOpen={isMenuOpen} />
      </button>
    )
  }
)

export default AccountToggleMobile
